<div class="sticky top-0 header">
  <div class="flex flex-col-reverse full-width bg-surface -mt-2">
    <div class="mb-3">
      <soft-step-header [steps]="steps" [currentIndex]="2" #stepper></soft-step-header>
    </div>
    <soft-default-header
      [overline]="'Schritt 3 von 4'"
      [title]="stepper.current()?.header | translate"
      [subtitle]="stepper.current()?.subHeader | translate"
    ></soft-default-header>
  </div>
</div>

<div class="pb-20">
  <div class="soft-overline mt-4">
    {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.MENGE' | translate}}
  </div>

  @if (artikel$ | async; as artikel) {
  <soft-stock-quantity-control
    class="mt-2 block"
    (quantityChange)="onMengeChange($event)"
    [product]="artikel.artikel"
    [unit]="artikel.einheit"
    [quantity]="artikel.menge"
    [artehEingabe]="artikel?.arteheingabe ?? false"
    [unitEntryId]="artikel?.idarteheingabe"
    [artehEingabeRequired]="artikel?.arteheingabePflicht ?? false"
  />
  }
</div>

<button
  class="fixed left-0 right-0 bottom-0 soft-button primary w-full h-20 mt-16"
  (click)="onSubmit()"
>
  {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.SUBMIT' | translate}}
</button>
